/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 */

import { LayoutState } from "../../../ui/components/Layout/LayoutState";
import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";

export const DocumentationLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.COLUMN,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.PANEL,
				id: "main",
				isExpandable: false,
				toolbarComponent: "toolbar",
				children: [
					{
						type: LAYOUT_TYPE.ROW,
						id: "mainRow",
						children: [
							{
								type: LAYOUT_TYPE.PANEL,
								id: "sidebar",
								isExpandable: false,
								contentComponent: "sidebar",
								size: "300px"
							},
							{
								type: LAYOUT_TYPE.SPLITTER,
								id: "docSplitter"
							},
							{
								type: LAYOUT_TYPE.PANEL,
								id: "content",
								isExpandable: false,
								contentComponent: "content"
							}
						]
					}
				]
			}
		]
	}
};

export function createDocumentationLayout(): LayoutState {
	return new LayoutState(DocumentationLayoutConfig);
}
